<template>
  <div class="align-items-center border-bottom header-bar">
    <omnisearch ref="omni" />
    <user-menu
      :user="user"
    />
  </div>
</template>

<script>
import UserMenu from './UserMenu'
import Omnisearch from './omnisearch/Omnisearch'

export default {
  components: {
    UserMenu,
    Omnisearch,
  },
  props: {
    user: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      searchQuery: '',
    }
  },
  methods: {

    mouseclick (...args) {
      this.$refs.omni.mouseclick.apply(this.$refs.omni.mouseclick, args)
    },
  },
}
</script>

<style lang="scss">
  .header-bar {
    height: 60px;
    padding: 0 72px;
    margin-left: $sidebar-width;
    background-color: $header-bar-bg;
    display: none;

    .el-input__inner {
      background: transparent;
      border: 0;
    }

    .user-menu {
      width: 195px;
      cursor: pointer;

      button {
        background: transparent;
        border: none;
      }

      a {
        color: inherit;
      }

      .i {
        top: 1px;
        width: 16px;
        height: 16px;
      }

      .down-icon {
        left: 4px;
      }
    }

    @media(max-width: 991px) {
      margin-left: 0 !important;
      padding: 0 1rem;
    }

    @media (min-width: 769px) {
      display: flex !important;
    }
  }

</style>
